import AppConstants from '../../Constants/AppConstants';

const storageKey = type => `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:listing-attributes:bulk:${type || 'default'}`;

const safeRows = rows => (Array.isArray(rows) ? rows : []).slice(0, 500).map(row => ({
  id: row?.id,
  order_by: typeof row?.order_by === 'number' || typeof row?.order_by === 'string' ? row.order_by : undefined,
  categoryIds: Array.isArray(row?.categoryIds) ? row.categoryIds.filter(id => typeof id === 'number' || typeof id === 'string').slice(0, 300) : [],
})).filter(row => row.id !== undefined && row.id !== null);

export const readBulkAttributeDraft = type => {
  if (typeof window === 'undefined') return [];
  try {
    const value = JSON.parse(window.localStorage.getItem(storageKey(type)) || '[]');
    return safeRows(value);
  } catch (error) {
    return [];
  }
};

export const writeBulkAttributeDraft = (type, rows) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(storageKey(type), JSON.stringify(safeRows(rows)));
  } catch (error) {
    // Keep the bulk editor usable if browser storage is unavailable.
  }
};

export const clearBulkAttributeDraft = type => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(storageKey(type));
  } catch (error) {
    // Ignore storage errors after a successful save.
  }
};
